"use client";

import { Comedian } from "@/data/comedians";
import React from "react";
import { SpecialRow } from "@/data/specials";
import { VideoReactionButton } from "../reactions/VideoReactionButton";

const ClapReactionButton = ({
  special,
  comedian,
  authenticated,
  className,
}: {
  special: SpecialRow;
  comedian: Comedian;
  authenticated: boolean;
  className?: string;
}) => {
  return (
    <VideoReactionButton
      special={special}
      comedian={comedian}
      authenticated={authenticated}
      className={className}
    />
  );
};

export default ClapReactionButton;
